import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=0206a65c&scoped=true"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=0206a65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206a65c",
  null
  
)

export default component.exports